import React from "react"
import { To, useNavigate } from "react-router-dom"
import { useAuth } from "~/context/auth";
import Error from '~/pages/Error';
import { route } from "~/helpers/routeHelper";
import { isUserVerifiedLocal } from "~/helpers/tokenHelper";
import { setDirectRoute } from "~/store/actions";
import { useAppDispatch } from "~/hooks/redux";
import { TAuthmiddleware } from "~/types/global";

const Authmiddleware = ({
  component,
  layout,
  isVerifRequired,
}: TAuthmiddleware) => {

  const { isLoggedIn, userError } = useAuth();

  const navigate = useNavigate();

  // redux hook that dispatches actions
  const dispatch = useAppDispatch();

  const Component = component as unknown as React.ComponentType<any>;
  const Layout = layout as unknown as React.ComponentType<any>;

  // remove 's' queryParam from url
  const manageDirectRoute = () => {
    let params = new URLSearchParams(window.location.search);
    params.delete('s');
    dispatch(setDirectRoute(`${window.location.pathname}?${params}`));
  }
  if (!isLoggedIn()) {
    // user is not authenticated
    return <Error error={userError} />
  }
  if (isLoggedIn() && !isUserVerifiedLocal() && isVerifRequired) {
    // when url contains specific route, for user to access after verification
    manageDirectRoute();
    // user is authenticated but not verified and the current route requires the user to be verified
    // so redirect to the verification screen
    navigate(route('welcome') as To)
    return <></>;
  }
  // user is free to access the page
  return <Layout>
    <Component />
  </Layout>
}

export default Authmiddleware;
